/* „Hogyan kéred a csomagodat?” ablak (snippets/bella-ship-modal.liquid).
   Minden fizetés-gomb (Dawn, EGO/Opus Shadow DOM-os drawer, kosároldal) kattintását elkapjuk,
   lefuttatjuk a kosár-őrt (window.BellaCartGuard), és megnyitjuk az ablakot; a Delivery Gateway
   drawerként ismeri fel és beleteszi a szállítási/csomagpont-választóját. Tovább: /checkout. */
(() => {
  const el = document.getElementById('bb-ship');
  if (!el) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const FREE = Number(el.dataset.free || 0) * 100;

  // tesztmód: ?bbship=1 bekapcsolja ebben a böngészőben, ?bbship=0 kikapcsolja
  let test = false;
  try {
    const q = new URL(location.href).searchParams.get('bbship');
    if (q === '1') localStorage.setItem('bb-ship-test', '1');
    if (q === '0') localStorage.removeItem('bb-ship-test');
    test = localStorage.getItem('bb-ship-test') === '1';
  } catch {}
  const active = el.dataset.live === 'true' || test;
  if (!active) return;

  const money = (c) => `${String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')} Ft`;
  const freeEl = el.querySelector('[data-bb-ship-free]');
  const go = el.querySelector('[data-bb-ship-go]');
  let lastFocus = null;

  async function refreshFree() {
    try {
      const c = await (await fetch(`${root}cart.js`, { credentials: 'same-origin' })).json();
      const left = FREE - c.total_price;
      // kézbesítés: csak órák (és az ajándék nyaklánc) → 1–2 munkanap, charmos ékszerrel 3–6
      const pt = window.BellaPT;
      const watchOnly = c.items.length > 0 && c.items.every((i) => (pt && (i.variant_id === pt.gift || pt.isWatch(i.variant_id))) || /vintage-ora|karora|mystery-nyaklanc/.test(i.handle || ''));
      const days = el.querySelector('[data-bb-ship-days]');
      if (days) days.textContent = watchOnly ? '1–2' : '3–6';
      freeEl.innerHTML = !FREE ? '' : left > 0
        ? `Még <b>${money(left)}</b>, és ingyenes a szállítás`
        : '<b>Ingyenes szállítás</b> ✓';
    } catch { freeEl.textContent = ''; }
  }

  function closeOpus() {
    // az EGO/Opus drawer (z 2147483640) bezárása, különben eltakarja az ablakot
    try {
      const sr = document.getElementById('opus-shadow-container')?.shadowRoot;
      if (!sr || !sr.querySelector('.opus-drawer-container.open')) return;
      const btn = sr.querySelector('.opus-drawer-container.open [class*="close" i]') || sr.querySelector('.cd-app-overlay');
      btn && btn.click();
    } catch {}
  }

  // A Live Product Options (Cloudlift) becsomagolja a window.fetch-et, és a Mapbox streamelt kéréseinél
  // hibát dob („duplex member must be specified”) → üres a DGW térkép. Megnyitáskor (amikor már minden app
  // betöltött) a térkép és a DGW kéréseit az eredeti fetch-re irányítjuk; minden más marad a régi úton.
  const NATIVE = /api\.mapbox\.com|events\.mapbox\.com|deliverygateway\.io/;
  function protectFetch() {
    const native = window.__bbNativeFetch;
    if (!native || window.fetch.__bbShip) return;
    const current = window.fetch;
    const wrapped = function (input, init) {
      const url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      return (NATIVE.test(url) ? native : current).apply(this, arguments);
    };
    wrapped.__bbShip = true;
    window.fetch = wrapped;
  }

  // A DGW (2026-10-26-i app-verzió óta) a választót néha a Dawn rejtett kosárfiókjának aljára (.drawer__footer) teszi
  // a custom drawerSelector helyett – ilyenkor átköltöztetjük a mi ablakunkba.
  const box = document.getElementById('bb-ship-dgw');
  function adoptDgw() {
    if (!box) return;
    const all = [...document.querySelectorAll('deliverygateway-io-drawer')];
    const mine = all.find((d) => el.contains(d));
    const stray = all.filter((d) => !el.contains(d));
    if (!mine && stray.length) box.appendChild(stray.shift());
    stray.forEach((d) => { if (el.contains(d)) return; d.style.display = 'none'; });
  }
  const adoptObs = 'MutationObserver' in window ? new MutationObserver(() => { if (!el.hidden) adoptDgw(); }) : null;

  function open() {
    protectFetch();
    if (adoptObs) adoptObs.observe(document.body, { childList: true, subtree: true });
    [0, 300, 1000, 2500].forEach((t) => setTimeout(adoptDgw, t));
    lastFocus = document.activeElement;
    closeOpus();
    el.hidden = false;
    // a DGW a drawerSelector (#bb-ship.is-open) megjelenésekor illeszti be a választót
    requestAnimationFrame(() => el.classList.add('is-open'));
    document.documentElement.classList.add('bb-ship-open');
    refreshFree();
    setTimeout(() => go.focus({ preventScroll: true }), 60);
    try { document.dispatchEvent(new CustomEvent('bella:ship:open')); } catch {}
  }
  function close() {
    if (adoptObs) adoptObs.disconnect();
    el.classList.remove('is-open');
    el.hidden = true;
    document.documentElement.classList.remove('bb-ship-open');
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }

  el.addEventListener('click', (e) => { if (e.target.closest('[data-bb-ship-close]')) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !el.hidden) close(); });
  go.addEventListener('click', async () => {
    go.setAttribute('aria-busy', 'true');
    if (window.BellaCartGuard) { try { await window.BellaCartGuard.check(); } catch {} }
    window.location.assign(`${root}checkout`);
  });

  // fizetés-gombok elkapása (a kosár-őr is ugyanezt a szelektort használja; ő előbb fut és ellenőriz)
  const CHECKOUT = '[name="checkout"], a[href*="/checkout"], [class*="checkout" i]:is(button, a)';
  document.addEventListener('click', (e) => {
    if (!el.hidden) return;
    const t = e.composedPath().find((n) => n instanceof Element && n.matches(CHECKOUT));
    if (!t || el.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  window.BellaShip = { open, close };
})();
